// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__Ltxap","skeleton":"Breadcrumb_skeleton__3Sqyg"};